import { useSyncExternalStore } from "react";

import type { AssignmentMap } from "../SettingsPayload";
import { generationSettingStore } from "../store/SettingsGenerationSettingStore";

/** 生成担当のマップ全体を購読する。枚ごとの抽出など導出の入力に使う。 */
export function useAssignments(): AssignmentMap {
    return useSyncExternalStore(
        (cb) => generationSettingStore.subscribeAssignments(cb),
        () => generationSettingStore.getAssignments()
    );
}
